<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <form class="forms-sample">
                        <b-form-group label="Menu Name">
                            <b-form-input v-model="menu.menuName"
                                          type="text" 
                                          placeholder="Name">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Description">
                            <b-form-textarea v-model="menu.description"
                                             :rows="3"
                                             :max-rows="6"
                                             placeholder="Description">
                            </b-form-textarea>
                        </b-form-group>
                        <b-form-group label="Active on">
                            <b-form-checkbox-group v-model="openingDays" 
                                                   :options="weekdays">
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label="From Time">
                            <vue-timepicker v-model="fromTime"
                                            :minute-interval="5">
                            </vue-timepicker>
                        </b-form-group>
                        <b-form-group label="To Time">
                            <vue-timepicker v-model="toTime"
                                            :minute-interval="5">
                            </vue-timepicker>
                        </b-form-group>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapActions, mapState, mapGetters } from'vuex'
import VueTimepicker from 'vue2-timepicker'
import MenuBasicInfoBase from '../Bases/MenuBasicInfoBase'
import TimeFormatter from '../../../../src/assets/js/TimeFormatter'
export default{
    name: 'menueditbasicinfo',
    extends : MenuBasicInfoBase,
    inject: ['eventBus'],
    components: {
        VueTimepicker
    },

    methods: {
        initializeWeekdays() {
            if(this.menu.monday) {
                this.openingDays.push(1);
            } 
            if(this.menu.tuesday) {
                this.openingDays.push(2); 
            } 
            if(this.menu.wednesday) {
                this.openingDays.push(3);
            } 
            if(this.menu.thursday) {
                this.openingDays.push(4);
            } 
            if(this.menu.friday) {
                this.openingDays.push(5);
            } 
            if(this.menu.saturday) {
                this.openingDays.push(6);
            } 
            if(this.menu.sunday) {
                this.openingDays.push(0);
            } 
        }
    },
    created() {
        this.fromTime = TimeFormatter.formatTime(this.menu.fromTime);
        this.toTime = TimeFormatter.formatTime(this.menu.toTime);
        this.openingDays = [];
        this.initializeWeekdays();
    }
}
</script>